module.exports = __webpack_public_path__ + "img/box9-07.6c869f29.png";